//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ChemicalLossDrawer from "./modules/ChemicalLossDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
export default {
  name: 'ChemicalLossList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    ChemicalLossDrawer: ChemicalLossDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/chemical/loss',
      pageTitle: '化学品损耗',
      addDisabled: false,
      userTree: [],
      //人员信息
      isorter: {
        column: 'loss_date',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'productName',
        colName: 'asset_id',
        title: '化学品产品名称',
        align: 'center'
      }, {
        dataIndex: 'assetCode',
        colName: 'asset_id',
        title: '化学品资产编号',
        align: 'center'
      }, {
        dataIndex: 'lossType_dictText',
        colName: 'loss_type',
        title: '损耗类型',
        align: 'center'
      }, {
        dataIndex: 'lossDose',
        colName: 'loss_dose',
        title: '损耗剂量',
        align: 'center'
      }, {
        dataIndex: 'lossDate',
        colName: 'loss_date',
        title: '损耗日期',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '记录人员',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.queryUserTreeList();
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    onDateLossDate: function onDateLossDate(value, dateArray) {
      this.queryParam.lossDateStart = dateArray[0];
      this.queryParam.lossDateEnd = dateArray[1];
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    }
  }
};